
export default function TrackerResumeTitle() {
    return (
        <tr>
            <th className="tracker-name">Name</th>
            <th className="tracker-hardware_id">Hardware ID</th>
            <th className="tracker-url">Server</th>
            <th className="tracker-port">Port</th>
            <th className="tracker-status"></th>
            <th className="tracker-status">Fleet</th>
        </tr>
    )
}
